/**
 * One colour per bot status, everywhere.
 *
 *   grey    - nothing is happening yet (PENDING, NOT_LOGGED_IN)
 *   info    - starting up / signed in, no work done yet
 *   primary - actually working
 *   warning - needs a human (2FA, CAPTCHA) or was interrupted (STOPPED)
 *   success - finished cleanly
 *   error   - failed
 */

export type ChipColor =
  | "default"
  | "primary"
  | "secondary"
  | "error"
  | "info"
  | "success"
  | "warning";

const STATUS_COLORS: Record<string, ChipColor> = {
  PENDING: "default",
  NOT_LOGGED_IN: "default",
  ECS_CONTAINER_STARTED: "info",
  LOGGED_IN: "info",
  PROCESSING: "primary",
  TWOFA: "warning",
  "2FA": "warning",
  CAPTCHA: "warning",
  STOPPED: "warning",
  FINISHED: "success",
  ERROR: "error",
  CRITICAL_ERROR: "error",
};

export function statusChipColor(status: string | null | undefined): ChipColor {
  return STATUS_COLORS[(status || "").toUpperCase()] ?? "default";
}

// Named exports so the call sites read as before.
export const taskRunStatusChipColor = statusChipColor;
export const botWorkStatusChipColor = statusChipColor;
